import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  getConfiguredInputs,
  getDisabledConfigFields,
  makeSignalSelector,
} from 'selectors/feature/inputs'
import { updateInputConfigs } from 'actions/feature/inputs'
import InputConfigEditor from './InputConfigEditor'

const makeMapStateToProps = () => {
  const signalSelector = makeSignalSelector()

  return (state, ownProps) => {
    const { uri, signalUri } = ownProps

    const configuredInputs = getConfiguredInputs(state)
    const signal = signalSelector(state, { signal: signalUri })
    const disabledConfigs = getDisabledConfigFields(state, {
      uri,
    })

    return {
      configuredInputs,
      signal,
      disabledConfigs,
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ updateInputConfigs }, dispatch),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const {
    fixedDataType,
    signalUri,
    floatingCircuit,
    inputConfig,
    ...restOwnProps
  } = ownProps
  const { configuredInputs } = stateProps
  const { updateInputConfigs: dispatchUpdateInputConfigs } = dispatchProps

  const signalUriOrFloatingCircuit = signalUri || floatingCircuit

  const {
    conditionsSharingConfig,
    dataType,
    description: selectedInputDescription,
  } = configuredInputs[signalUriOrFloatingCircuit] || {}

  const onInputConfigChange = (config) =>
    dispatchUpdateInputConfigs(config, conditionsSharingConfig)

  const requirePrompt =
    conditionsSharingConfig && conditionsSharingConfig.length > 1

  return {
    ...restOwnProps,
    ...stateProps,
    inputConfig,
    dataType: fixedDataType || dataType,
    selectedInputDescription,
    onInputConfigChange,
    requirePrompt,
  }
}

const InputConfigEditorContainer = connect(
  makeMapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InputConfigEditor)

export default InputConfigEditorContainer
